import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CameraPreview } from '@capacitor-community/camera-preview';
import { IonModal } from '@ionic/angular/standalone';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';
import { AlertService } from 'src/app/services/alert.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-take-photo',
  templateUrl: './take-photo.component.html',
  styleUrls: ['./take-photo.component.scss'],
  standalone: true,
  imports: [
    IonicComponentsModule
  ]
})
export class TakePhotoComponent {

  //#region Propiedades

  @ViewChild("modal") public modal: IonModal
  public stopped: boolean = false
  public foto: string = null
  public hash: string = null
  @Output("foto-hecha") public fotoHecha = new EventEmitter<{
    data: string,
    hash: string
  }>()
  public identifier: string

  //#endregion

  //#region Constructor

  constructor(
    private util: UtilService,
    private alertService: AlertService
  ) { }

  //#endregion

  //#region Init

  public ngOnInit(): void {
    this.identifier = 'dvTakePhoto' + Math.floor(Math.random() * 1000000000).toString()
  }

  //#endregion

  //#region Modal

  public async show(): Promise<void> {
    try {
      this.stopped = false
      this.modal.isOpen = true
      await this.util.Sleep(1)
      await CameraPreview.start({ parent: this.identifier, width: 640, height: 640, position: 'rear' })
    } catch (ex) {
      console.error(ex)
      this.alertService.showMessage('No se ha podido acceder a la cámara.')
    }
  }

  public async onDismiss(): Promise<void> {
    await CameraPreview.stop()
    await this.util.Sleep(1)
    this.modal.isOpen = false
  }

  //#endregion

  //#region Foto

  public async hacerFoto(): Promise<void> {
    let foto = await CameraPreview.capture({
      quality: 100,
      width: 1920,
      height: 1920
    })
    this.foto = `data:image/jpeg;base64,${foto.value}`
    this.hash = await this.util.SHA256FromBase64Data(foto.value)
    await CameraPreview.stop()

    this.stopped = true
  }

  public async repetirFoto(): Promise<void> {
    this.stopped = false
    await this.util.Sleep(1)
    CameraPreview.start({ parent: this.identifier, width: 640, height: 640 })
  }

  public confirmarFoto(): void {
    this.modal.dismiss()
    this.fotoHecha.emit({
      data: this.foto,
      hash: this.hash
    })
  }

  //#endregion

}
